<template>
  <div id="planos">
    <SectionAtual />
    <SectionPlanos />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStorePerfil } from '@stores'
import SectionPlanos from '@components/app/reativar/partials/SectionPlanos.vue'
import SectionAtual from '@components/app/reativar/partials/SectionAtual.vue'

const router = useRouter()
const storePerfil = useStorePerfil()

async function verificarAssinatura() {
  await storePerfil.receberPerfilUsuario()
  if (storePerfil.usuario?.assinatura?.ativo === true) {
    router.push('/inicio')
  }
}

onMounted(() => {
  verificarAssinatura()
})
</script>

<style scoped>
#planos {
  animation: fadeIn 0.3s linear;
}
@media screen and (max-width: 1000px) {
  #planos {
    padding: 0;
  }
}
</style>
